import { UrlConstants } from "../url.constants";
export class ApiZoningCertificateConstants {
    static URL = UrlConstants.API_V2 + "ZoningCertificate";
    static FUNCTION_SET_APPLICANT_AND_APPLICANT_AGENT = "SetZoningCertificateApplicantAndApplicantAgent";
    static FUNCTION_SET_PROPERTIES = "SetZoningCertificateProperties";
    static FUNCTION_GET_GENERATE_INVOICE = "GenerateZoningCertificateInvoiceReport";
    static FUNCTION_GET_MY_AFLA_PORTAL_ZONING_CERTIFICATE_APPLICATIONS = "GetMyAFLAPortalZoningCertificateApplications";
    static FUNCTION_CREATE_PARTIAL_APPLICATION = "CreatePartialPortalZoningCertificateApplication";
}
